import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import DouglasPeuckerLineSimplifier from './DouglasPeuckerLineSimplifier';
import GeometryTransformer from '../geom/util/GeometryTransformer';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Polygon from '../geom/Polygon';
import LinearRing from '../geom/LinearRing';
import MultiPolygon from '../geom/MultiPolygon';
var DouglasPeuckerSimplifier = /*#__PURE__*/function () {
  function DouglasPeuckerSimplifier() {
    _classCallCheck(this, DouglasPeuckerSimplifier);
    DouglasPeuckerSimplifier.constructor_.apply(this, arguments);
  }
  _createClass(DouglasPeuckerSimplifier, [{
    key: "setEnsureValid",
    value: function setEnsureValid(isEnsureValidTopology) {
      this._isEnsureValidTopology = isEnsureValidTopology;
    }
  }, {
    key: "getResultGeometry",
    value: function getResultGeometry() {
      if (this._inputGeom.isEmpty()) return this._inputGeom.copy();
      return new DPTransformer(this._isEnsureValidTopology, this._distanceTolerance).transform(this._inputGeom);
    }
  }, {
    key: "setDistanceTolerance",
    value: function setDistanceTolerance(distanceTolerance) {
      if (distanceTolerance < 0.0) throw new IllegalArgumentException('Tolerance must be non-negative');
      this._distanceTolerance = distanceTolerance;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._inputGeom = null;
      this._distanceTolerance = null;
      this._isEnsureValidTopology = true;
      var inputGeom = arguments[0];
      this._inputGeom = inputGeom;
    }
  }, {
    key: "simplify",
    value: function simplify(geom, distanceTolerance) {
      var tss = new DouglasPeuckerSimplifier(geom);
      tss.setDistanceTolerance(distanceTolerance);
      return tss.getResultGeometry();
    }
  }]);
  return DouglasPeuckerSimplifier;
}();
export { DouglasPeuckerSimplifier as default };
var DPTransformer = /*#__PURE__*/function (_GeometryTransformer) {
  _inherits(DPTransformer, _GeometryTransformer);
  function DPTransformer() {
    var _this;
    _classCallCheck(this, DPTransformer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPTransformer).call(this));
    DPTransformer.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(DPTransformer, [{
    key: "transformPolygon",
    value: function transformPolygon(geom, parent) {
      if (geom.isEmpty()) return null;
      var rawGeom = _get(_getPrototypeOf(DPTransformer.prototype), "transformPolygon", this).call(this, geom, parent);
      if (parent instanceof MultiPolygon) return rawGeom;
      return this.createValidArea(rawGeom);
    }
  }, {
    key: "createValidArea",
    value: function createValidArea(rawAreaGeom) {
      if (this._isEnsureValidTopology) return rawAreaGeom.buffer(0.0);
      return rawAreaGeom;
    }
  }, {
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      var inputPts = coords.toCoordinateArray();
      var newPts = null;
      if (inputPts.length === 0) newPts = new Array(0).fill(null);else newPts = DouglasPeuckerLineSimplifier.simplify(inputPts, this._distanceTolerance);
      return this._factory.getCoordinateSequenceFactory().create(newPts);
    }
  }, {
    key: "transformMultiPolygon",
    value: function transformMultiPolygon(geom, parent) {
      var rawGeom = _get(_getPrototypeOf(DPTransformer.prototype), "transformMultiPolygon", this).call(this, geom, parent);
      return this.createValidArea(rawGeom);
    }
  }, {
    key: "transformLinearRing",
    value: function transformLinearRing(geom, parent) {
      var removeDegenerateRings = parent instanceof Polygon;
      var simpResult = _get(_getPrototypeOf(DPTransformer.prototype), "transformLinearRing", this).call(this, geom, parent);
      if (removeDegenerateRings && !(simpResult instanceof LinearRing)) return null;
      return simpResult;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._isEnsureValidTopology = true;
      this._distanceTolerance = null;
      var isEnsureValidTopology = arguments[0],
        distanceTolerance = arguments[1];
      this._isEnsureValidTopology = isEnsureValidTopology;
      this._distanceTolerance = distanceTolerance;
    }
  }]);
  return DPTransformer;
}(GeometryTransformer);
DouglasPeuckerSimplifier.DPTransformer = DPTransformer;